import template from './nonRacingEvents.html';
import controller from './nonRacingEvents.controller';
import './nonRacingEvents.scss';

let nonRacingEventsComponent = {
  restrict: 'E',
  bindings: {
    raceday: '<'
  },
  template,
  controller
};

export default nonRacingEventsComponent;
